import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
// import Footer from 'components/Footer';
import Tour from '../components/Tour/index';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
import { isIOS, isMobile } from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';
import jwtDecode from "jwt-decode";

const WaitingRoomManagement = asyncComponent(() => import('./routes/WaitingRoomManagement'));

class App extends React.Component {

  render() {
    const { match, drawerType, navigationStyle, horizontalNavPosition, userType } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    let payload = jwtDecode(localStorage.getItem("mhc"))

    return (
      <div className={`app-container ${drawerStyle}`}>
        <Tour />

        <Sidebar />
        <div className="app-main-container">
          <div
            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
              <TopNav styleName="app-top-header" />}
            <Header />
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
              <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route path={`${match.url}dashboard`} component={asyncComponent(() => import('./routes/Dashboard'))} />
                {/* Admin Management */}
                <Route path={`${match.url}user`} component={asyncComponent(() => import('./routes/User'))} />
                <Route path={`${match.url}adminRole`} component={asyncComponent(() => import('./routes/AdminRole'))} />
                <Route path={`${match.url}adminPermission`} component={asyncComponent(() => import('./routes/AdminPermission'))} />
                <Route path={`${match.url}adminRolePermission`} component={asyncComponent(() => import('./routes/AdminRolePermission'))} />

                {/* Patient Management */}
                <Route path={`${match.url}business`} component={asyncComponent(() => import('./routes/PatientManagement/Business'))} />

                <Route path={`${match.url}patient`} component={asyncComponent(() => import('./routes/PatientManagement/Patient'))} />

                {/* Doctor Management */}
                <Route path={`${match.url}hospital`} component={asyncComponent(() => import('./routes/DoctorManagement/Hospital'))} />

                <Route path={`${match.url}doctor`} component={asyncComponent(() => import('./routes/DoctorManagement/Doctor'))} />

                <Route path={`${match.url}admin`} component={asyncComponent(() => import('./routes/DoctorManagement/Admin'))} />

                {/* Realtime Stats */}
                <Route path={`${match.url}realtimeStats`} component={asyncComponent(() => import('./routes/RealtimeStats'))} />

                {/* Teleconference Log */}
                <Route path={`${match.url}teleconferenceLog`} component={asyncComponent(() => import('./routes/TeleconferenceLog'))} />

                {/* Prescription Purchase */}
                <Route path={`${match.url}prescriptionpurchase`} component={asyncComponent(() => import('./routes/PrescriptionPurchase'))} />

                {/* Prescription External */}
                <Route path={`${match.url}prescriptionexternal`} component={asyncComponent(() => import('./routes/PrescriptionExternal'))} />

                {/* Promo Code */}
                <Route path={`${match.url}promo`} component={asyncComponent(() => import('./routes/PromoCode'))} />

                {/* Voucher Code */}
                <Route path={`${match.url}voucher`} component={asyncComponent(() => import('./routes/VoucherCode'))} />

                {/* Marketplace */}
                <Route path={`${match.url}marketPlace`} component={asyncComponent(() => import('./routes/Marketplace'))} />

                {/* Market Place Redeemption */}
                <Route path={`${match.url}redeem`} component={asyncComponent(() => import('./routes/MarketPlaceRedeemption'))} />

                {/* Appointment */}
                <Route path={`${match.url}appointment`} component={asyncComponent(() => import('./routes/Appointment'))} />

                {/* Push Notification */}
                <Route path={`${match.url}notify`} component={asyncComponent(() => import('./routes/PushNotification'))} />

                {/* EDM Email */}
                <Route path={`${match.url}edmEmail`} component={asyncComponent(() => import('./routes/EdmEmail'))} />

                {/* announcement */}
                <Route path={`${match.url}announcement`} component={asyncComponent(() => import('./routes/Announcement'))} />

                {/* Drugs List */}
                <Route exact path={`${match.url}drugs/category/list/:catId`} component={asyncComponent(() => import('./routes/DrugsList'))} />

                <Route exact path={`${match.url}drugs/category`} component={asyncComponent(() => import('./routes/DrugsList/DrugCategory/List'))} />

                <Route exact path={`${match.url}drugs/category/create`} component={asyncComponent(() => import('./routes/DrugsList/DrugCategory/Create'))} />

                <Route exact path={`${match.url}drugs/category/detail/:categoryId`} component={asyncComponent(() => import('./routes/DrugsList/DrugCategory/Edit'))} />

                {/* Symptom */}
                {/* <Route path={`${match.url}symptom`} component={asyncComponent(() => import('./routes/Symptom'))} /> */}

                <Route path={`${match.url}symptomCategory`} component={asyncComponent(() => import('./routes/Symptom/Category'))} />

                <Route path={`${match.url}symptomGroup`} component={asyncComponent(() => import('./routes/Symptom/Group'))} />

                {/* MarketPlace Drug */}
                <Route path={`${match.url}all_drug`} component={asyncComponent(() => import('./routes/MarketPlaceDrug/AllDrugs'))} />

                <Route path={`${match.url}category`} component={asyncComponent(() => import('./routes/MarketPlaceDrug/CategoryDrugs'))} />

                <Route exact path={`${match.url}purchased_drug/detail/:order_id`} component={asyncComponent(() => import('./routes/MarketPlaceDrug/NormalDrugs/Detail'))} />

                <Route path={`${match.url}purchased_drug`} component={asyncComponent(() => import('./routes/MarketPlaceDrug/NormalDrugs'))} />

                 {/* Ewallet */}
                 <Route path={`${match.url}ewallet`} component={asyncComponent(() => import('./routes/Ewallet'))} />
                 {/* Ewallet */}

                 <Route path={`${match.url}menuplaceholder`} component={asyncComponent(() => import('./routes/MenuPlaceholder'))} />

                 <Route path={`${match.url}businessPackage`} component={asyncComponent(() => import('./routes/BusinessPackage'))} />

                 <Route path={`${match.url}mainSpeciality`} component={asyncComponent(() => import('./routes/MainSpeciality'))} />

                 <Route path={`${match.url}speciality`} component={asyncComponent(() => import('./routes/Speciality'))} />
                {/* Profession Management */}
                 <Route path={`${match.url}profession`} component={asyncComponent(() => import('./routes/Profession'))} />
                 <Route path={`${match.url}professionClinicConfiguration`} component={asyncComponent(() => import('./routes/Profession/ProfessionClinicConfiguration'))} />
                {/* Profession Management */}
                 <Route path={`${match.url}gstSetting`} component={asyncComponent(() => import('./routes/GstSetting'))} />
                 
                 <Route path={`${match.url}patientSearchAll`} component={asyncComponent(() => import('./routes/PatientSearchAll'))} />

                 <Route path={`${match.url}userSessions`} component={asyncComponent(() => import('./routes/UserSessions'))} />

                 <Route path={`${match.url}waitingRoom`} component={asyncComponent(() => import('./routes/WaitingRoom'))} />

                 {/* Apppintment Management */}
                 <Route exact path={`${match.url}appointmentmanagement`} component={asyncComponent(() => import('./routes/AppointmentManagement'))} />

                 <Route exact path={`${match.url}createappointment`} component={asyncComponent(() => import('./routes/AppointmentManagement/CreateAppointmentManagement'))} />

                 <Route exact path={`${match.url}createappointment/addschedule`} component={asyncComponent(() => import('./routes/AppointmentManagement/CreateAppointmentManagement/AddSchedule'))} />

                  <Route exact path={`${match.url}createappointment/addspecialschedule`} component={asyncComponent(() => import('./routes/AppointmentManagement/CreateAppointmentManagement/AddSpecialSchedule'))} />

                 <Route exact path={`${match.url}updateappointment`} component={asyncComponent(() => import('./routes/AppointmentManagement/UpdateAppointmentManagement'))} />

                 <Route exact path={`${match.url}updateappointment/editschedule/:schedule_id`} component={asyncComponent(() => import('./routes/AppointmentManagement/UpdateAppointmentManagement/EditSchedule'))} />

                 <Route exact path={`${match.url}updateappointment/editspecialschedule/:special_schedule_id/:clinic_id`} component={asyncComponent(() => import('./routes/AppointmentManagement/UpdateAppointmentManagement/EditSpecialSchedule'))} />

                 {/* Appointment Management */}

                 {/* Waiting Room Management */}
                <Route path={`${match.url}waitingRoomManagement`} component={WaitingRoomManagement} />

                 {/* All Appointments */}
                 {/* <Route exact path={`${match.url}appointmentmanagement/allappointments`} component={asyncComponent(() => import('./routes/AppointmentManagement/AllAppointments'))} /> */}
                 {/* <Route exact path={`${match.url}appointmentmanagement/allappointments`} component={asyncComponent(() => import('./routes/AppointmentManagement/DoctorAppointments'))} /> */}
                 <Route exact path={`${match.url}appointmentmanagement/allappointments`} component={asyncComponent(() => payload.role_id === 17 ? import('./routes/AppointmentManagement/DoctorAppointments') : import('./routes/AppointmentManagement/AllAppointments'))} />

                 <Route exact path={`${match.url}appointmentmanagement/appointmentdetails/:appointment_id`} component={asyncComponent(() => import('./routes/AppointmentManagement/AllAppointments/AppointmentDetails'))} />
                 {/* All Appointments */}

                 {/* Version */}
                 <Route path={`${match.url}version`} component={asyncComponent(() => import('./routes/Version'))} />

                 {/* Report */}
                 <Route path={`${match.url}report/sla_report`} component={asyncComponent(() => import('./routes/Report/SlaReport'))} />
                 <Route path={`${match.url}report/slaReportStatus`} component={asyncComponent(() => import('./routes/Report/SlaReportStatus'))} />
                 <Route path={`${match.url}report/waitingRoomAnalysis`} component={asyncComponent(() => import('./routes/Report/WaitingRoomAnalysisNew'))} />
                 <Route path={`${match.url}report/teleconsult`} component={asyncComponent(() => import('./routes/Report/Teleconsult'))} />

                  {/* Consent */}
                  <Route path={`${match.url}consentTemplate`} component={asyncComponent(() => import('./routes/Consent/ConsentTemplate'))} />
                  <Route path={`${match.url}consentUser`} component={asyncComponent(() => import('./routes/Consent/ConsentUser'))} />
                  {/* Consent */}

                 <Route path={`${match.url}selfassessment`} component={asyncComponent(() => import('./routes/SelfAssessment'))} />
                <Route path={`${match.url}selfassessmentfirst`} component={asyncComponent(() => import('./routes/SelfAssessmentFirst'))} />
                <Route path={`${match.url}selfassessmentresult`} component={asyncComponent(() => import('./routes/SelfAssessmentResult'))} />
                <Route path={`${match.url}articles`} component={asyncComponent(() => import('./routes/Articles'))} />
                {/* Log Out */}
              </Switch>
            </div>
            {/* <Footer /> */}
          </main>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({ settings, auth }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  const { userType } = auth;

  return { drawerType, navigationStyle, horizontalNavPosition, userType }
};
export default withRouter(connect(mapStateToProps)(App));
